import {UserService} from '@/services';

const state = {}

const getters = {}

const actions = {}

const mutations = {}

export const User = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}